const userProfile = {
    userProfile: {
        caption: 'My Profile',
    }
};

export default userProfile;
